import { CountryCode } from '@marketplace-web/country/country-data'

import { getBannerSectionContent } from './banner-section'
import { getExamplesSectionContent } from './example-section'
import { getFactsSectionContent } from './facts-section'
import { getIntroductionSectionContent } from './introduction-section'
import { getListingSectionContent } from './listing-section'
import { getProofSectionContent } from './proof-section'
import { getQuestionSectionContent } from './question-section'
import { getTipSectionContent } from './tip-section'

const getContentLayout1 = (countryCode = 'UK', isDarkMode = false) => [
  getIntroductionSectionContent(),
  getBannerSectionContent(countryCode),
  getFactsSectionContent(countryCode, isDarkMode, 3),
  getProofSectionContent(countryCode),
  getExamplesSectionContent(countryCode, 3),
  getQuestionSectionContent(countryCode, isDarkMode),
  getTipSectionContent(),
  getListingSectionContent(),
]

const getContentLayout2 = (countryCode = 'UK', isDarkMode = false) => [
  getIntroductionSectionContent(),
  getBannerSectionContent(countryCode),
  getFactsSectionContent(countryCode, isDarkMode, 2),
  getExamplesSectionContent(countryCode, 2),
  getQuestionSectionContent(countryCode, isDarkMode),
  getTipSectionContent(),
  getListingSectionContent(),
]

const getContentLayout3 = (countryCode = 'UK', isDarkMode = false) => [
  getIntroductionSectionContent(),
  getBannerSectionContent(countryCode),
  getFactsSectionContent(countryCode, isDarkMode, 1),
  getQuestionSectionContent(countryCode, isDarkMode),
  getTipSectionContent(),
  getListingSectionContent(),
]

const getContentLayout4 = (countryCode = 'UK', isDarkMode = false) => [
  getIntroductionSectionContent(),
  getBannerSectionContent(countryCode),
  getFactsSectionContent(countryCode, isDarkMode, 1),
  getProofSectionContent(countryCode),
  getExamplesSectionContent(countryCode, 1),
  getQuestionSectionContent(countryCode, isDarkMode),
  getTipSectionContent(),
  getListingSectionContent(),
]

export const dac7LayoutMapper = [
  {
    countries: [CountryCode.Uk, CountryCode.Pl],
    layout: getContentLayout1,
  },
  {
    countries: [CountryCode.Fr],
    layout: getContentLayout2,
  },
  {
    countries: [
      CountryCode.It,
      CountryCode.Nl,
      CountryCode.Be,
      CountryCode.Cz,
      CountryCode.Sk,
      CountryCode.Ro,
      CountryCode.Pt,
      CountryCode.Dk,
    ],
    layout: getContentLayout3,
  },
  {
    countries: [CountryCode.Es],
    layout: getContentLayout4,
  },
]

export const fallbackLayout = getContentLayout1
